import React from 'react'

const Item = ({code, name, quantity, category, subCategory, onClickRow, inventoryType, id}) => {
  return (
    <React.Fragment>
        <span onClick={()=>onClickRow(inventoryType, id)}>{code}</span>
        <span onClick={()=>onClickRow(inventoryType, id)}>{name}</span>
        <span onClick={()=>onClickRow(inventoryType, id)}>{quantity}</span>
        <span onClick={()=>onClickRow(inventoryType, id)}>{category}</span>
        <span onClick={()=>onClickRow(inventoryType, id)}>{subCategory}</span>
    </React.Fragment>
  )
}

export default Item